import { takeEvery, put, call, all, fork } from "@redux-saga/core/effects";
import { USER_LOGOUT, USER_LOGOUT_SUCCESS } from "redux/constants/portal";
import { userLogout } from "api/Auth0Api";

/***** WORKERS *****/

function* handleUserLogout({ payload }) {
   try {
      const { tenant_id, auth0_id } = payload;
      yield call(userLogout, auth0_id, tenant_id);
   } catch (error) {
      console.error(error);
   } finally {
      yield put({ type: USER_LOGOUT_SUCCESS });
   }
}

/***** WATCHERS *****/

function* watchUserLogout() {
   yield takeEvery(USER_LOGOUT, handleUserLogout);
}

export function* rootAuthSaga() {
   yield all([fork(watchUserLogout)]);
}
